<my-modal #approvalModal [useCustomFooter]="true" [classes]="['modal-lg']" (hideModal)="onApprovalModalHide()">
  <div modal-title class="tw-text-xl">Edit Option</div>
  <div modal-body>
    <div class="tw-text-lg tw-mb-1">{{ option.name }}</div>
    <div class="tw-text-md tw-mb-2">{{ optionParentName }}</div>
    <div class="approvals-modal modal-content" *ngIf="initializeModalCalculator">
      <app-approval-smart
        [approvalsCount]="1"
        [approval]="optionParent"
        [useStoreApprovals]="false"
        [hideHeader]="true"
        [editModalOverrideData]="editApprovalData"
        (calculationUpdate)="handleCalculationUpdate($event)"
      >
      </app-approval-smart>
    </div>
  </div>
  <div modal-footer>
    <button
      class="btn btn-default"
      (click)="closeModal()"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      (click)="saveOption('approval')"
      [disabled]="false"
    >
      Save
    </button>

  </div>
</my-modal>

<my-modal #offerModal [hideFooter]="true">
  <div modal-title class="tw-text-xl">Edit Option</div>
  <div modal-body>
    "Coming soon!"
  </div>
</my-modal>
